import React from 'react';
import { useState } from "react";
import {Link } from 'react-router-dom' 
import { useSelector, useDispatch } from 'react-redux' 
//import {ColorChangingCircle} from "./ColorChangingCircle.tsx";
import './Account.css' 
import { InputRadio, RadioBox } from '../../atoms'
import { ProfileForm } from '../../molecules'
import { ModalWindow, Form,  } from '../../organisms'
import {useFormValidation} from '../../../utils/Validator.js'
import { updateUserParametrs, editPhoto, getUserBonus, getUserTransaction, changeSubscription, verifyPayment, extensionSubs} from '../../../store/api.js'

export function Account(props) { 
  const { currentUser, rate, statusUser } = useSelector(state => state.currentUser)
  const { bonus, statusBonus, transaction } = useSelector(state => state.payment)
  const { lib, statusLib } = useSelector(state => state.lib)  
  console.log(currentUser)
  const d = rate && new Date(rate.endDate); 
  const dispatch = useDispatch()
  const day = String(d.getDate()).padStart(2, '0'); // Получаем день и добавляем ноль перед числом, если нужно
  const month = String(d.getMonth() + 1).padStart(2, '0'); // Получаем месяц и добавляем ноль, так как months начинаются с 0
  const year = d.getFullYear()  
  const formattedDate = `${day}.${month}.${year}`; 
  const [bmi, setBmi] = useState(null); 
  const [gender, setGender] = React.useState(''); 
  const [rates, setRates] = React.useState([]); 
  const [isOpen, setIsOpen] = React.useState(false); 
  const [isOpenInfoBonus, setIsOpenInfoBonus] = React.useState(false) 
  const [payment, setPayment] = React.useState(0)
  const [isOpenPay, setIsOpenPay] = React.useState(false);
  const [isOpenBonus, setIsOpenBonus] = React.useState(false);
  const [showChangeModal, setShowChangeModal] = useState(false);
  const [showRenewModal, setShowRenewModal] = useState(false);
  const [useBonus, setUseBonus] = useState(false);
  const [availableBonus, setAvailableBonus] = useState(0);
  const [bonusToUse, setBonusToUse] = useState(0); 
  const [selectedSubscription, setSelectedSubscription] = useState({})
  const [activityLevel, setActivityLevel] = useState(1.55); 
  const [goal, setGoal] = useState("maintain"); 
  const [bmr, setBmr] = useState(0);
  const [calories, setCalories] = useState(0);
  const [protein, setProtein] = useState(0);
  const [fat, setFat] = useState(0);
  const [carbs, setCarbs] = useState(0); 
  const [promocode, setPromocode] = useState(''); 
  
    const activityLevels = [
    { value: 1.2, label: "Минимальный (сидячий образ жизни)" },
    { value: 1.375, label: "Легкий (легкие тренировки 1-3 раза в неделю)" },
    { value: 1.55, label: "Умеренный (тренировки 3-5 раз в неделю)" },
    { value: 1.725, label: "Высокий (интенсивные тренировки 6-7 раз)" },
    { value: 1.9, label: "Очень высокий (тяжелая работа + тренировки)" },
  ];
  const options = [
    { value: 'female', label: 'Ж' },
    { value: 'male', label: 'М' }, 
  ]; 
  const renewalOptions = [
    { months: 1, discount: 0, label: '1 месяц' },
    { months: 3, discount: 20, label: '3 месяца (-20%)' },
    { months: 6, discount: 30, label: '6 месяцев (-30%)' },
    { months: 12, discount: 45, label: '12 месяцев (-45%)' },
  ];
 
  const goals = [
    { value: "lose", label: "Снижение веса" },
    { value: "maintain", label: "Поддержание веса" },
    { value: "gain", label: "Набор веса" },
  ]; 
  const { 
    values, 
    handleChange, 
    setValues,
    handleFocus,
    handleBlur,
  } = useFormValidation({
    age: 0,
    height: 0,
    weight: 0, 
  });
 
   const pay = {
    event: 'payment.succeeded',
    object:  {
      id: '30116fe1-000f-5001-9000-15e688b2b311',
      status: 'succeeded',
      amount: { value: '1466.00', currency: 'RUB' },
      income_amount: { value: '1414.69', currency: 'RUB' },
      description: 'Смена подписки на "Семейный" (списано бонусов: 0)',
      recipient: { account_id: '1123739', gateway_id: '2495704' },
      payment_method: {
        type: 'bank_card',
        id: '30116fe1-000f-5001-9000-15e688b2b311',
        saved: false,
        status: 'inactive',
        title: 'Bank card *0002',
        card: [Object]
      },
      captured_at: '2025-07-22T09:39:03.118Z',
      created_at: '2025-07-22T09:38:41.790Z',
      test: true,
      refunded_amount: { value: '0.00', currency: 'RUB' },
      paid: true,
      refundable: true,
      metadata: {
        period: 'sixmonths',
        subsId: '682b5c4ae36c3225dcae51b8',
        usedBonus: '0',
        userId: '633d4694ded217300ce32fe5',
        paymentId: '26f622c6-782b-4ca2-96f3-0d2ac7ad2bbf'
      },
      authorization_details: {
        rrn: '863090027014485',
        auth_code: '370915',
        three_d_secure: [Object]
      }
    }
  
    
   }

  React.useEffect(()=> { 
    dispatch(getUserBonus())
    dispatch(getUserTransaction())
    // dispatch(postPayment(pay))
    
  },[])  

 /* React.useEffect(() => {
    const paymentAttempt = localStorage.getItem('paymentAttempt'); 
    if (paymentAttempt) {
      const attempt = JSON.parse(paymentAttempt);
      console.log(attempt)
      if(rate.rateId ===attempt.subsId ) {
        console.log(rate.rateId,attempt.subsId )
        localStorage.removeItem('paymentAttempt');
      } else {
        alert('Платеж в обработке');
       // Проверить статус платежа через API
       dispatch(verifyPayment(attempt.paymentId))
      } 

     
    }
  }, []);*/

   
  React.useEffect(()=> {
     if(statusUser !== 'resolved') return;
     if(statusLib !== 'resolved') return;  
      setPromocode('')
       setValues({
         age: currentUser.age,
         weight: currentUser.parameters?.[0]?.weight,
         height: currentUser.height, 
       }) 
       setCalories(currentUser.parameters?.[0]?.calories || 0)
       setProtein(currentUser.parameters?.[0]?.protein  || 0)
       setFat(currentUser.parameters?.[0]?.fat  || 0)
       setCarbs(currentUser.parameters?.[0]?.carb  || 0)
       setBmi(currentUser.parameters?.[0]?.bmi  || 0)
       setGender(currentUser.gender)
       setActivityLevel(currentUser.parameters?.[0]?.activity || 1.55) 
       let calculatedBmr; 
       if (currentUser.gender === "male") {
        calculatedBmr = 88.36 + (13.4 * currentUser.parameters?.[0]?.weight) + (4.8 * currentUser.height) - (5.7 * currentUser.age);
      } else {
        calculatedBmr = 447.6 + (9.2 * currentUser.parameters?.[0]?.weight) + (3.1 * currentUser.height) - (4.3 * currentUser.age);
      }
      setBmr(Math.round(calculatedBmr));
      const availableSubscriptions = lib.rates.filter( r => r._id !== rate.rateId 
        //&& r.subs !== 'free' 
        ); 
      setSelectedSubscription(availableSubscriptions[0]) 
      setRates(availableSubscriptions);
      setAvailableBonus(currentUser?.bonusAccount?.balance) 

    const paymentAttempt = localStorage.getItem('paymentAttempt'); 
    if (paymentAttempt) {
      const attempt = JSON.parse(paymentAttempt);
      console.log(attempt)
      if(rate.rateId ===attempt.subsId && rate.endDate === attempt.endDate) {
        console.log(rate.rateId,attempt.subsId )
        localStorage.removeItem('paymentAttempt');
        alert('Платеж прошел успешно');
      } else { 
       // Проверить статус платежа через API
       dispatch(verifyPayment(attempt.paymentId))
       alert('Платеж в обработке');
      }  
    }
   
  },[statusUser, statusLib])

  React.useEffect(() => {
    if (isOpen || isOpenPay || isOpenBonus || isOpenInfoBonus || showRenewModal || showChangeModal) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    } 
    return () => {
      document.body.style.overflow = '';
      document.body.style.paddingRight = ''
    };
   }, [isOpen, isOpenPay, isOpenBonus, isOpenInfoBonus, showChangeModal, showRenewModal]);

  const handleGenderChange = (event) => { 
    setGender(event.target.value);
  } 

  const toggleModal = () => { 
      setTimeout(() => {
        setIsOpen(false);
        setIsOpenInfoBonus(false) 
        setShowRenewModal(false) 
        setShowChangeModal(false) 
        setIsOpenBonus(false) 
        setIsOpenPay(false) 
        setPromocode('')
      }, 300); // Должно совпадать с duration анимации
    
  };


  ////////////////////////////////////////////////////////Обработка подписок  //////////////////////////////////////////////////////////
  const handlePromocode = (promo) => {
    console.log(promo)
    setPromocode(promo)
  }
  const handleChangeSub= (sub) => {
    setSelectedSubscription(sub)
  }

  //Смена подписки с учетом оставшихся дней
  const handleSubscriptionChange = (isActive, priceSale, period, bonus) => {  
    setShowChangeModal(false); 
    // Здесь должен быть вызов API для сохранения изменений  
    dispatch(changeSubscription({isActive, priceSale, period, bonus, newSubs: selectedSubscription._id, promocode})) 
  };

  // Обработчик продления подписки
  const handleRenewSubscription = (isActive, priceSale, period, bonus) => { 
    setShowRenewModal(false);  
    dispatch(extensionSubs({isActive, priceSale, period, newSubs: rate.rateId, promocode})) 
  };
  
    // Обработчик использования бонусов
    const handleBonusUseChange = (e) => {
      setUseBonus(!useBonus)
      const value = parseInt(e.target.value);
     
    };

 //////////////////////////////////////   ПОдсчет КБЖУ ////////////////////////////////////////////
  const bmiValue = () => {
    const heightInMeters = values.height / 100;
    const calculatedBmi = values.weight / (heightInMeters * heightInMeters);
    setBmi(calculatedBmi.toFixed(1));
    let calculatedBmr; 
    if (gender === "male") {
      calculatedBmr = 88.36 + (13.4 * values.weight) + (4.8 * values.height) - (5.7 * values.age);
    } else {
      calculatedBmr = 447.6 + (9.2 * values.weight) + (3.1 * values.height) - (4.3 * values.age);
    }
    setBmr(Math.round(calculatedBmr));
    let calculatedCalories = calculatedBmr * activityLevel;
    setCalories(Math.round(calculatedCalories));
    setGoal("maintain")
    handleCalc(goal, calculatedBmi.toFixed(1), Math.round(calculatedBmr))
  }


  const handleCalc = (goal, bmi, bmr) => { 
    setGoal(goal) 
    let calculatedCalories = bmr * activityLevel;
    if (goal === "lose") calculatedCalories -= 500;
    if (goal === "gain") calculatedCalories += 500;
    setCalories(Math.round(calculatedCalories)); 
    // 4. Расчет БЖУ
    // Белки: 1.5-2.5 г/кг (больше для набора массы)
    const proteinPerKg = goal === "gain" ? 2.5 : goal === "lose" ? 2 : 1.8;
    const calculatedProtein = Math.round(values.weight * proteinPerKg);
    setProtein(calculatedProtein);

    // Жиры: 0.8-1.5 г/кг (минимум 25% от калорий)
    const fatPerKg = 1;
    const calculatedFat = Math.round(values.weight * fatPerKg);
    setFat(calculatedFat);

    // Углеводы: остаток калорий
    const carbPerKg = goal === "gain" ? 5 : goal === "lose" ? 2.5 : 4;
    const calculatedCarb = Math.round(values.weight * carbPerKg);
    const proteinCalories = calculatedProtein * 4;
    const fatCalories = calculatedFat * 9;
    const carbCalories = calculatedCarb * 4;
    const remainingCalories = carbCalories +  proteinCalories + fatCalories;  
    setCarbs(calculatedCarb); 
    dispatch(updateUserParametrs({
      gender, 
      age: values.age, 
      height: values.height, 
      weight: values.weight,
      activity: activityLevel,
      calories: Math.round(calculatedCalories),
      protein: calculatedProtein,
      fat: calculatedFat,
      carb: calculatedCarb, 
      bmi: bmi
    }))
  };
   

  ///////////////////////////////////////Изменение данных профиля//////////////////////////

  const handleEditProfile = () => { 
    setIsOpen(true)
  } 

  const handleClose = () => { 
    setIsOpen(false)
    setIsOpenPay(false)
    setIsOpenBonus(false)
    setIsOpenInfoBonus(false)
    setShowRenewModal(false)
    setShowChangeModal(false)
    setPromocode('')
  } 

  const toggleOpenHistoryBonus = () => {
    setIsOpenBonus(true)
  }

  const toggleOpenHistoryPay = () => {
    setIsOpenPay(true)
  }

  const toggleOpenInfoBonus = () => {
    setIsOpenInfoBonus(true)
  }

  return (
    <> 
      {Object.keys(currentUser).length !== 0 && statusUser === 'resolved' &&
    <section className={`account__section ${statusUser === 'loading' ? 'loading' : ''}`} >
      <div className="account__leftbar">
        <div className="account__item">
          {currentUser.photo === '' ? 
          <p className='gg-photo-off'></p>
          : 
          <img className="account__my-photo" src={currentUser.photo} alt="Мое фото" />
          }
           <div className='account__my-info'>
          <div className='font20EB colorGrey'>{currentUser.name}</div> 
          <div className='font12Norm colorGrey'>{currentUser.email}</div>
          </div>
          <button type='button' className='gg-edit m-size' onClick={handleEditProfile}/>  
        </div>
        <div className="account__item">
          <div className="account__item_rate  widt50">
            <div className='font14EB colorGrey'>Тарифный план</div>
            <div className='font20EB color'>{rate.title}</div> 
            <div className='font20EB color'>{rate.price}<span className='font14EB color'> ₽/мес </span></div> 
            {rate.subs !== 'free' &&
           <button type='button' className='buttonGreen buttonGreenMini' onClick={() => setShowRenewModal(true)}> Продлить </button>  
          }
          </div> 
          <div className="account__item_rate widt50 ai-e"> 
          <div className='account__item_access font12Norm colorGrey '> Дата окончания {formattedDate}</div> 
          <div className='font12Norm item__link widt70 ta-r' onClick={toggleOpenHistoryPay}> История списаний / начислений </div>
         
         
          <button type='button' className='buttonGreen mt-auto' onClick={() => setShowChangeModal(true)}> Сменить  </button>  
         
          </div>
        </div> 
        <div className="account__item">
          <div className="account__item_rate">
            <div className='account__item_bonus' >
            <div className='gg-bonus'></div>
            <div className='font20EB color'>Бонусы</div> 
            <div className='font12Norm colorGrey'> 1Б = 1Р </div>
            </div>
            
            <div className='font32EB colorGrey'>{availableBonus}Б</div>
          </div> 
          <div className="account__item_rate account__item_rate-bonus"> 
          <div className='font12Norm item__link ml-a'  onClick={toggleOpenHistoryBonus}> История</div>  
          <div className='font12Norm item__link' onClick={toggleOpenInfoBonus}> Как получить бонусы </div>
          </div>
        </div>  
      </div> 
      <div className="account__rigthbar">
        <div className="account__item account__item_rate">
        <div className="font20EB color">Рассчитать индекс массы тела и получить рекомендации</div>  
        <form className="flexRowStart display-reverse">
          <div className="account__item_rate account__item_rate-weight">
            <InfoInput title='Возраст' name='age' id='age' value={values.age} onChange={handleChange} onFocus={handleFocus}
          onBlur={handleBlur}/>
            <InfoInput title='Рост, см' name='height' id='height' value={values.height} onChange={handleChange} onFocus={handleFocus}
          onBlur={handleBlur}/>
            </div>
            <div className="account__item_rate account__item_rate-weight "> 
          <InfoInput title='Вес, кг' name='weight' id='weight' value={values.weight} onChange={handleChange} onFocus={handleFocus}
          onBlur={handleBlur}/>
          <fieldset className='flexRowStart'>
            <legend className='font14EB colorGrey'>Пол </legend> 
            <InputRadio
              options={options}
              selectedValue={gender}
              onChange={handleGenderChange}
              name='gender'
            />
          </fieldset>
        </div>
          
        </form> 
   
        <div className="flexRowStart"> 
        
        <select
          value={activityLevel}
          onChange={(e) => setActivityLevel(parseFloat(e.target.value))}
          className={`select-item font20Norm select-item_${props.type}`}
        >
          {activityLevels.map((level) => (
            <option key={level.value} value={level.value}>
              {level.label}
            </option>
          ))}
        </select>

          {/* <Selectdisign data={activityLevels}  name={sort} isOpen={select} handleChangeEvents={handleChangeEvents} handlePopupModal={handlePopupModal} type='activity'/>
         */} <button type='button' className='buttonGreen' onClick={bmiValue}> Рассчитать  </button>
          
        </div> 
        </div>
        <div className="account__item account__item_mobile">   
            <div className="account-bmi-section">
            <div className='account__item_bmi'>
              <div className="font20EB color">
                Ваш имт
              </div>
              <p className={`font32EB account-bmi__value colorGrey ${!bmi ? 'item__search': ""}`}>
           
            {  bmi ? bmi : 0}</p> 
            </div> 
            <div className='account__item_advice'>
              <button className={`font12Norm colorGrey account-bmi-button ${!bmi ? 'buttonDisabled ': "buttonRed"}`} >
                {getBmiCategory(bmi)}
              </button>
              {bmi &&
              <div className='account__item_advices'>
                <p className='font12Norm'>Рекомендуется:</p> 
              <span className='font12Norm colorGrey'>{advice(bmi)}</span>
              </div>
              }
              </div>
            </div>
            <div className="account-recommendations">
              <h3 className="  font20EB color">
                Рекомендации по подбору плана питания
              </h3>
              
              <div className="account-recommendations-content">
              <div className="account__item_recount"> 
                <div className="account-radio-section font4Norm"> 
       {goals.map((g) => (
      <label key={g.value} className='font14Norm item__link' style={{ display: "flex", alignItems: "center" }}>
        <input
          type="radio"
          name="goal"
          value={g.value}
          checked={goal === g.value}
          disabled={!bmi}
          onChange={(e) => handleCalc(e.target.value, bmi, bmr) }
          style={{ marginRight: "5px" }}
        />
        {g.label}
      </label>
    ))}
      </div>    
     <div className='account__item_advices'>
     <div className='font14EB colorGrey '>Норма калорий</div>
                  <div className={`font32EB al-s ${bmi ? 'color': 'item__search'}`} >{bmi ? calories : 0}<span className={`font18EB  ${bmi ? 'color-title': 'item__search'}`}> ккал</span> </div>
    </div>
    </div>        
               
                
              </div>
            </div>
          </div> 
      
      </div> 
     </section>
   }
  {/*Модальное окно редактирования профиля*/}
  {isOpen &&
    <ModalWindow  isOpen={isOpen} onClose={handleClose} title='profile' head='' toggleModal={toggleModal} >
      <EditProfile formattedDate={formattedDate} />
    </ModalWindow>
  }

  {/*Модальное окно редактирования профиля*/}
  {isOpenPay &&
    <ModalWindow  isOpen={isOpenPay} onClose={handleClose} title='history-pay' head=''  toggleModal={toggleModal} >
      <HistoryPay formattedDate={formattedDate} />
    </ModalWindow>
  }
 
  {/*Модальное окно истории бонусов*/}
  {isOpenBonus &&
    <ModalWindow  isOpen={isOpenBonus} onClose={handleClose} title='history-bonus' head=''  toggleModal={toggleModal} >
      <HistoryBonus bonusTransactions={bonus.bonusTransactions} />
    </ModalWindow> 
  }
 
  {/*Модальное окно редактирования профиля*/}
  {isOpenInfoBonus &&
    <ModalWindow onClose={handleClose} title='info-bonus' head='Программа бонусов'   toggleModal={toggleModal}>
      <InfoBonus formattedDate={formattedDate} />
    </ModalWindow> 
  }

  {/* Модальное окно смены подписки */}
  {showChangeModal &&
  <ModalWindow onClose={handleClose} title='user' head=''  toggleModal={toggleModal}> 
    <EditRate 
      setShowChangeModal={setShowChangeModal} 
      handleSubscriptionChange={handleSubscriptionChange} 
      setSelectedSubscription={setSelectedSubscription}
      selectedSubscription={selectedSubscription}
      handleBonusUseChange={handleBonusUseChange}
      useBonus={useBonus}
      availableBonus={availableBonus} 
      bonusToUse={bonusToUse}
      rates={rates} 
      payment={payment}
      handleChangeSub={handleChangeSub}
      type='change ' 
      handlePromocode={handlePromocode}
    />
  </ModalWindow> 
  }

  {showRenewModal &&
  <ModalWindow  onClose={handleClose} title='user' head='' toggleModal={toggleModal} > 
  <EditRate 
      setShowChangeModal={setShowChangeModal} 
      handleSubscriptionChange={handleSubscriptionChange} 
      setSelectedSubscription={setSelectedSubscription}
      selectedSubscription={selectedSubscription}
      handleBonusUseChange={handleBonusUseChange}
      useBonus={useBonus}
      availableBonus={availableBonus}
      handlePromocode={handlePromocode}
      bonusToUse={bonusToUse}
      rates={rates} 
      payment={payment}
      handleChangeSub={handleChangeSub}
      type='change'
      handleRenewSubscription={handleRenewSubscription}
    /> 
  </ModalWindow> 
  }
 


      
</>

  );
}


const InfoInput = (props) => { 
  return(
    <div>
      <label className='font14EB colorGrey'> {props.title}
      <input
          type="number"
          id={props.id}
          name={props.name} 
          placeholder = '0'
          value={props.value}
          className={`form__input form__input_limit font20Norm`}
          onChange={props.onChange} 
          onFocus={props.onFocus}
          onBlur={props.onBlur}
        /> 
      {props.error && <span className="form__text_error font14Norm">{props.error}</span>}
    </label>
    </div>
  )
} 

const getBmiCategory = (bmi) => {
  if (bmi < 10 ) return "Категория";
  if (bmi < 16.5 && bmi > 10) return "Выраженный дефицит";
  if (bmi < 18.5) return "Недостаточный вес";
  if (bmi < 25) return "Норма";
  if (bmi < 30) return "Избыточный вес";
  if (bmi < 35) return "Ожирение 1 степени";
  return "Ожирение 2-3 степени";
};

const advice = (bmi) => {
  if (bmi < 18.5) return "Увеличение веса";
  if (bmi < 25) return "Поддержание веса";
  if (bmi > 25) return "Снижение веса"; 
};


const EditProfile = ({formattedDate, handleClose}) => {
  const { currentUser, rate, statusUser } = useSelector(state => state.currentUser)
  const dispatch = useDispatch() 
  const { values, handleChange, isValid, emailError, 
  } = useFormValidation({
    email: '', password: '' });
  const submitDisabled = values.email === '' || values.password === '' || !isValid ||   emailError;
 
  React.useEffect(()=> {
   
  },[currentUser])

  const handleAddPhoto = async (e) => { 
    const file = e.target.files[0];
    
    if (!file) return;
  
    // 1. Проверка, что файл - изображение
    if (!file.type.startsWith('image/')) {
      alert('Пожалуйста, выберите файл изображения (JPEG, PNG, etc.)');
      return;
    }
   
    // 2. Проверка размера (например, не больше 5MB)
    if (file.size > 5 * 1024 * 1024) {
      alert('Файл слишком большой! Максимальный размер: 5MB.');
      return;
    }

    // 3. Преобразование в base64
    const base64String = await convertToBase64(file); 
    // 4. Отправка на сервер (base64 строка)
    dispatch(editPhoto(base64String));
  };

// Функция преобразования File в base64
const convertToBase64 = (file) => { 
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
};
  
  //Отправка данных
  function handleSubmit(e) {
    e.preventDefault();
   
  }  
  return (
    <div className='profile_modal profile__modal_edit js-b'>
      <div className='profile__modal_edit-info '>
      <div className='relative'>
        {currentUser.photo === '' ? 
          <p className='gg-photo-off'></p>
        : <img className="account__my-photo" src={currentUser.photo} alt="Мое фото" />
        }
         
        <label className='account__photo_file cursor-pointer' htmlFor='photo'>
          <input 
          type='file' 
          onChange={handleAddPhoto} 
          className="hidden widt30" 
          name='photo' 
          id='photo'
          /> 
          <div className='account__photo_edit'>
            <span className='gg-edit m-size'></span>
           </div>
         </label> 
       </div>
        <div className="account__item_rate account__item_edit-rate">
           <div className='font14EB colorGrey'>Тарифный план</div>
           <div className='title-price-wrapper'>
           <div className='font20EB color'>{rate.title}</div>   
            <div className='font20EB color price-mobile'>{rate.price}<span className='font14EB color'> ₽/мес</span></div>
          </div> 
          <div className='font12Norm colorGrey account__item_access-edit'> Дата окончания {formattedDate}</div>
          <div className=' font20EB color price-desktop'>{rate.price}<span className='font14EB color'> ₽/мес </span></div>
        </div> 
      </div>
      <div className='account__data_info'>
        <ProfileForm  onClose={handleClose}/>
      </div>
    </div>
  )
}

const HistoryPay = ({}) => {

  return (
    <div className='df-r profile_modal js-b'> 
      <div className='recipe_none'>
        <p className='gg-no-dish'></p> 
        <p className=' font20Nprm '>Ничего не найдено</p> 
      </div> 
    </div>
  )
}

const HistoryBonus = ({bonusTransactions}) => {
  return (
    <div className='df-c js-b profile_modal '>
    <h3 className="font18EB colorGrey">История платежей</h3>
    <ul className='df-c js-b g20'>
      {bonusTransactions?.length > 0 ?
      bonusTransactions.map(item=> (
        <li key={item._id} item={item} className='df-r ai-c g20'>
          <p className={`m-size ${item.type === 'out'? 'gg-debit' : 'gg-credit'}`}></p>
          <p className='font14Norm colorGrey'>{FormattedDate(item.createdAt)}</p>
          <p  className='font14Norm colorGrey'>{item.description} {item.sourceName}</p>
        <p  className='font14Norm colorGrey ml-a'> {item.amount} Б</p>
        </li>
      )) 
      : 
      <div className='recipe_none'>
        <p className='gg-no-dish'></p> 
        <p className=' font20Nprm '>Ничего не найдено</p> 
      </div> 
      }
    </ul>
    </div>
  )
}

const InfoBonus = ({}) => {
 
  return (
    <div className='df-c profile_modal profile_modal_info js-b'> 
      <div class="bonus-header">
        <h3 className="font20EB color">Программа бонусов за рецепты</h3>
      </div>
  
  <p className="font20Norm colorGrey">
    За каждый выложенный рецепт вы получаете <span class="highlight">20 бонусов</span>, 
    которые можно использовать для оплаты подписки:
  </p>
  
  <div className="subscription-cost"> 
    <span className="font20Norm colorGrey">1 месяц подписки = 250 бонусов</span>
  </div>
  
  <h3 className="conditions-title font20EB colorGrey">Условия начисления:</h3>
  <ol className='df-c ai-s g20'>  
    <li className="font14Norm colorGrey ta-c">Бонусы зачисляются после модерации рецепта (обычно в течение 24 часов)</li> 
    <li className="font14Norm colorGrey ta-c">Рецепт и фотография должны быть авторскими (скопированные из других источников не учитываются)</li> 
    <li className="font14Norm colorGrey ta-c">Рецепт должен быть общедоступным — за приватные рецепты бонусы не начисляются</li>
  </ol>
  <div className='df-c ai-c g20'>  
    <p className="font20EB colorGrey">Как потратить бонусы? </p>
    <span className="font14Norm colorGrey">При следующем продлении подписки выберите оплату бонусами.</span>
    <span className='widt70 font20EB colorGrey'>Остались вопросы? Напишите нам в <Link to='https://t.me/menubook_ru' target="_blank" rel="noreferrer" className='color-title font20EB' >Поддержку</Link>!</span>
  </div> 
  </div> 
  )
}

const EditRate = ({ 
  handleSubscriptionChange, 
  selectedSubscription, 
  rates, 
  availableBonus,
  handleRenewSubscription,
  type, 
  handleChangeSub,   
  handlePromocode 

}) => {
 
  const { currentUser, rate, statusUser } = useSelector(state => state.currentUser)
  const price = type !== 'change' ? selectedSubscription.price : rate.price
  const [isActive, setIsActive] = React.useState(false);
  const [sale, setSale] = React.useState(1)
  const { lib, statusLib } = useSelector(state => state.lib)  
  const [promoText, setPromoText] = React.useState('')
  const [errorCode, setErrorCode] = React.useState('')
  const [promo, setPromo] = React.useState('')
  const [period, setPeriod] = useState('month')
  const [priceSale, setPriceSale] = useState(0)
  const [priceBase, setPriceBase] = useState(0)
  const [bonus, setBonus] = useState(0) 
  const [endDate, setEndDate] = useState(null) 
  const formattedDate = endDate ? endDate.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
}).replace(/\./g, '.') : null;

  React.useEffect(()=> {
    if(statusLib === 'resolved' && promoText) {
      const searchDate =  lib.promocode.find(p=> p.title ===promoText && new Date() <new Date(p.dateAcces))
      if(searchDate) {
        setSale(1-searchDate.sale/100)
        setErrorCode('')
      } else {
        setSale(1)
        setErrorCode('Введен неверный промокод или он недействителен!')
      }
    }
  },[lib, promoText])

  React.useEffect(()=> { 
    setPriceSale(countPriceSale(price, period, sale, isActive))
    setPriceBase(countPriceBase(price, period))
  },[isActive, sale, period, price])

  function handleChangePromo(e) {
    setPromo(e.target.value) 
  }

  function hadleSubmitPromocode(text) { 
    setPromoText(text)  
    handlePromocode(text)
  }

  const handleToggle = (e) => {
    const newValue = e.target.checked;
    setIsActive(newValue); 
  };
 
  function countPriceSale(price, period, sale, isActive) {
    const salePrice = period === 'threemonth' ? Math.ceil(price*0.8*3) : period === 'sixmonths' ? Math.ceil(price*0.7*6) : period === 'year' ? Math.ceil(price*0.55*12) : Math.ceil(price)
    let prices =salePrice
    if ( type !== 'change') {
    const rateDate = new Date(rate.endDate); 
    const remainingDays = Math.floor((rateDate - new Date()) / (1000 * 60 * 60 * 24));// количество оставщихся дней по старой пописке
    const dailyRateCurrent = Math.ceil(rate.price/30 * remainingDays) // остаток суммы oплаченной
    if(dailyRateCurrent > prices) {
      const countDay = Math.floor(dailyRateCurrent/(selectedSubscription.price/30))
      let endDate = new Date();
      endDate.setDate(endDate.getDate() + countDay);
      endDate.setHours(23, 59, 59, 999);
      setEndDate(endDate)
      prices = 0 
    } else {
      setEndDate(null)
      const bonus =  Math.min(availableBonus, salePrice)
      setBonus(Math.min(availableBonus, salePrice))
      console.log(salePrice,bonus, dailyRateCurrent, sale)
      prices =  isActive ? Math.ceil((salePrice- dailyRateCurrent - bonus)*sale) : Math.ceil((salePrice-dailyRateCurrent)*sale)
    }
  } else {
    setEndDate(null)
      const bonus =  Math.min(availableBonus, salePrice)
      setBonus(Math.min(availableBonus, salePrice))
      prices =  isActive ? Math.ceil((salePrice - bonus)*sale) : Math.ceil(salePrice*sale)
  }
    console.log(prices)
    return prices
  } 
 
  function countPriceBase(price, period,) {
    return period === 'threemonth' ? Math.ceil(price*3) : period === 'sixmonths' ? Math.ceil(price*6) : period === 'year' ? Math.ceil(price*12) : price
  }

  function handleChangePeriod(e) { 
    setPeriod(e.target.value) 
  }
   
  const toggleSubscriptionChange = () => { 
    if(type !== 'change') {
      handleSubscriptionChange(isActive, priceSale, period, bonus)
    } else { 
      handleRenewSubscription(isActive, priceSale, period, bonus)
    }
   
  }
  return (
    <div className="df-c profile_modal g10 ai-c"> 
    <h3 className='colorGrey font14EB'>{`${type === 'change' ? 'Продлить тарифный план' : 'Сменить тарифный план'}`} </h3>
    <h3 className='colorGrey font14Norm item__search'>Текущий тариф: <span className='greyUp'> {rate.title}</span></h3>
    <div className="subscription__block">
      {type !== 'change' &&
      rates.map(sub => (
        <div 
          key={sub._id} 
          className={`subscription-option item__link ${selectedSubscription._id === sub._id ? 'subs__selected' : ''}`}
          onClick={()=> handleChangeSub(sub)}
        >
          <h4 className='greyUp font16Norm'>{sub.title} </h4> 
        </div>
      ))}
    </div>
    <Sale onChange={handleChangePeriod} period={period} onChangePromo={handleChangePromo} errorCode={errorCode} hadlePromocode={hadleSubmitPromocode} promo={promo}/>
    {availableBonus > 0 &&
    <div className='df-r ai-c g10 colorGrey font14Norm' >  Списать бонусы?
      <label className="toggle-switch">
        <input 
          type="checkbox" // Изменено с range на checkbox
          checked={isActive}
          onChange={handleToggle}
          className="toggle-input" 
        />
        <span className="toggle-slider"></span>
       <span className="toggle-labels">
        <span className="toggle-label"></span>
       <span className={`${isActive ? 'd-none' : 'toggle-label'}`}> {availableBonus} Б</span>
       </span>
     </label>
     </div> 
    } 
   
    <p className='rate__price font46EB color'>
    {priceSale !== selectedSubscription.price &&  <span className='rate__price_no-sale font14Norm'>{priceBase} ₽</span>}
          {priceSale} ₽</p>
      <button className='buttonGreen' onClick={toggleSubscriptionChange}>{`${type === 'change' ? 'Продлить' : 'Сменить тариф'}`}</button>
     {formattedDate && 
      <span className='form__text_error font14Norm'> С учетом оплаченного периода, при смене тарифа на "{selectedSubscription.title}" подписка будет действовать до {formattedDate}</span>
     }
    </div> 
  )

}
 
const FormattedDate = (dateString) => { 
  if (!dateString) return null; 
  const d = new Date(dateString);
  if (isNaN(d.getTime())) return null;

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();

  return (
    `${day}.${month}.${year}`
  )
};


const Sale = (props) => {
  return (
    <form className='sale__account'>
      <RadioBox onChange={props.onChange} period={props.period} type='account'/>  
      <div className='account__promocode df-c g10'>    
        <label className='promo__label js-b font20Norm' htmlFor='promo'>
          <input 
            type="text" 
            value={props.promo || ''} 
            onChange={props.onChangePromo} 
            placeholder='Промокод'  
            className='promo__input promo__input_account'
            name='promo' 
            id='promo' />
         <button type='button' className="gg-ok l-size" onClick={()=>props.hadlePromocode(props.promo)}></button> 
        </label>
        
       
         {props.errorCode !=='' && <span className='form__text_error font14Norm'>{props.errorCode} </span>}
      </div>
     </form>
    )
  }

  